import { routes } from '@/app/routing/router'
import { GamedUpdating } from './view'

const currentRoute = routes.updating

const UpdatingRoute = {
  route: currentRoute,
  view: GamedUpdating,
}

export { currentRoute, UpdatingRoute }
